/**
 * Tur programı (gün açıklaması) HTML'inden satır içi yazı boyutu, renk ve eski font etiketlerini çıkarır.
 * Böylece sayfa tipografisi (ProductTourDetail) tutarlı kalır; TinyMCE kaynaklı inline stiller geçersiz sayılır.
 */
export function stripTourProgramTypography(html: string): string {
    if (!html || typeof html !== 'string') {
        return '';
    }
    let s = html;
    // Satır içi style (font-size, color, font-family vb.)
    s = s.replace(/\sstyle\s*=\s*["'][^"']*["']/gi, '');
    // Eski <font color size face>
    s = s.replace(/<font\b[^>]*>/gi, '');
    s = s.replace(/<\/font>/gi, '');
    // Nadiren kalan renk / yüz öznitelikleri
    s = s.replace(/\sface\s*=\s*["'][^"']*["']/gi, '');
    s = s.replace(/\scolor\s*=\s*["'][^"']*["']/gi, '');
    s = s.replace(/\ssize\s*=\s*["']?[^"'\s>]+["']?/gi, '');
    return s;
}
